export enum TermsDocId {
  TERMS_OF_USE = "TERMS_OF_USE",
  PRIVACY_POLICY = "PRIVACY_POLICY",
}

export interface TermsOfUse {
  id: TermsDocId;
  version: number;
  link: string;
}

export interface TermsResponse {
  terms: TermsOfUse[];
}
